import React, { Fragment, ReactNode } from "react";

export type AddressType = { line1: string; line2?: Maybe<string>; city: string; postcode: string };

type AddresLines = keyof AddressType;
const addressLines: Array<AddresLines> = ["line1", "line2", "city", "postcode"];
const getAddressFragments = (address: AddressType): ReactNode[] =>
  addressLines
    .filter((line) => typeof address[line] === "string" && address[line] !== "")
    .reduce<ReactNode[]>(
      (fragments, line) => [
        ...fragments,
        <Fragment key={`addr-${line}`}>
          {address[line] as string}
          <br />
        </Fragment>,
      ],
      []
    );

export const Address: React.FC<{ value: AddressType }> = ({ value }) => <address>{getAddressFragments(value)}</address>;
